__turbopack_context__.v({
  "input": "PlpFiltersMake-module-scss-module__fLLo_G__input",
  "link": "PlpFiltersMake-module-scss-module__fLLo_G__link",
  "listSwitch": "PlpFiltersMake-module-scss-module__fLLo_G__listSwitch",
  "listTitle": "PlpFiltersMake-module-scss-module__fLLo_G__listTitle",
  "root": "PlpFiltersMake-module-scss-module__fLLo_G__root",
  "selectedOption": "PlpFiltersMake-module-scss-module__fLLo_G__selectedOption",
  "selectedOptionLabel": "PlpFiltersMake-module-scss-module__fLLo_G__selectedOptionLabel",
  "selectedOptionType": "PlpFiltersMake-module-scss-module__fLLo_G__selectedOptionType",
  "selectedOptions": "PlpFiltersMake-module-scss-module__fLLo_G__selectedOptions",
});
